/* CONCEPTS */
export const CONCEPT_LOAD = "CONCEPT_LOAD";
export const CONCEPT_LOAD_SUCCESS = "CONCEPT_LOAD_SUCCESS";
export const CONCEPT_ERROR = "CONCEPT_ERROR";
export const CONCEPT_SAVE = "CONCEPT_SAVE";
export const CONCEPT_SAVE_SUCCESS = "CONCEPT_SAVE_SUCCESS";
export const CONCEPT_DELETE = "CONCEPT_DELETE";
export const CONCEPT_DELETE_SUCCESS = "CONCEPT_DELETE_SUCCESS";
export const CONCEPT_CLEAN = "CONCEPT_CLEAN";